// extracted by mini-css-extract-plugin
export var actionButton = "_hi-0";
export var actionMenuContainer = "_hi-i";
export var bubble = "_hi-2";
export var bubbleActionMenu = "_hi-j";
export var bubbleContext = "_hi-6";
export var bubbleItems = "_hi-7";
export var customer = "_hi-3";
export var divider = "_hi-8";
export var fileList = "_hi-9";
export var hiddenComment = "_hi-o";
export var infoAbove = "_hi-a";
export var internal = "_hi-4";
export var lightActionButton = "_hi-1";
export var link = "_hi-b";
export var merchant = "_hi-5";
export var message = "_hi-c";
export var profilePicture = "_hi-e";
export var quillToolbarContainer = "_hi-f";
export var senderDate = "_hi-g";
export var senderDateCustomer = "_hi-h";
export var senderName = "_hi-d";
export var time = "_hi-k";
export var uploadedImage = "_hi-l";
export var username = "_hi-m";
export var xsmall = "_hi-n";